import React, { useEffect, useState} from 'react';
import PaginationDiv from '../../components/BlogElements/PaginationDiv';
import SideBar from '../../components/BlogElements/SideBar';
import NewsBlock from '../../components/ConsultancyElements/NewsBlock';
import BlogService from '../../services/BlogService';
import CoustomPagination from '../../components/common/Pagination';
import {Spin} from 'antd'

const BlogStandardContainer = () => {
    const [blogs, setBlogs] = useState([]);
    const [pagninatedData, setPagninatedData] = useState([]);
    const [loading, setLoading] = useState(false);

    console.log("blgos state values ", blogs);
    useEffect(() => {
        fetchBlogs();
    }, [])

    const fetchBlogs = async () => {
        try {
            setLoading(true);
            const response = await BlogService.getBlogList();
            const publishedBlogs = response.data.filter(
                (blog) => blog.isPublished === true
            );

            setBlogs(publishedBlogs);
        } catch (error) {
            console.log("error occurred while fetching blogs", error);
        } finally {
            setLoading(false);
        }
    };

    return (
      <section className="news-section">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-8 col-md-7 blog-card-list-top"
              style={{ width: "100%" }}
            >
              {pagninatedData.map((data) => (
                <NewsBlock key={data.id} data={data} />
              ))}
              {blogs.length > 0 && (
                <CoustomPagination
                  allData={blogs}
                  setPagninatedData={setPagninatedData}
                  pageSize={3}
                />
              )}
            </div>
            <Spin spinning={loading}>

            </Spin>

            {/* <SideBar /> */}
          </div>
        </div>
      </section>
    );
};

export default BlogStandardContainer;